export default __webpack_public_path__ + "static/media/Beppe6.06c56f58.jpg";